import { render, staticRenderFns } from "./Politic.vue?vue&type=template&id=6e15581b&"
import script from "./Politic.vue?vue&type=script&lang=js&"
export * from "./Politic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports